/* eslint-disable */

const ModelTag = ({
  modelId,
  isSmall = false,
  isShowingIcon = true,
  isOutline = false,
  onClick = null,
}) => {
  let title = "Unknown";

  let showTitle = true;
  let paddingX = "px-3";

  let colorBackgroundDark = "dark:bg-color-dark-debug-red";
  let colorBackgroundLight = "bg-color-debug-red";
  let colorBorderDark = "dark:border-color-dark-debug-red";
  let colorBorderLight = "border-color-debug-red";
  let colorTextDark = "text-color-debug-red";
  let colorTextLight = "text-color-debug-red";

  if (modelId === null || modelId === undefined) {
    modelId = "unknown";
  }
  if (onClick === null) {
    onClick = () => {
      navigator.clipboard.writeText(modelId);
    };
  }

  if (modelId.startsWith("account__")) {
    title = "Account";
    colorBackgroundDark = "dark:bg-color-dark-model-account";
    colorBackgroundLight = "bg-color-model-account";
    colorBorderDark = "dark:border-color-dark-model-account";
    colorBorderLight = "border-color-model-account";
    colorTextDark = "dark:text-color-dark-model-account";
    colorTextLight = "text-color-model-account";
  }

  if (modelId.startsWith("account_plan__")) {
    title = "Account Plan";
    colorBackgroundDark = "dark:bg-color-dark-model-account-plan";
    colorBackgroundLight = "bg-color-model-account-plan";
    colorBorderDark = "dark:border-color-dark-model-account-plan";
    colorBorderLight = "border-color-model-account-plan";
    colorTextDark = "dark:text-color-dark-model-account-plan";
    colorTextLight = "text-color-model-account-plan";
  }

  if (modelId.startsWith("account_plan_execution__")) {
    title = "Account Plan Execution";
    colorBackgroundDark = "dark:bg-color-dark-model-account-plan-execution";
    colorBackgroundLight = "bg-color-model-account-plan-execution";
    colorBorderDark = "dark:border-color-dark-model-account-plan-execution";
    colorBorderLight = "border-color-model-account-plan-execution";
    colorTextDark = "dark:text-color-dark-model-account-plan-execution";
    colorTextLight = "text-color-model-account-plan-execution";
  }

  if (modelId.startsWith("account_plan_sausage__")) {
    title = "Account Plan Sausage";
    colorBackgroundDark = "dark:bg-color-dark-model-account-plan-sausage";
    colorBackgroundLight = "bg-color-model-account-plan-sausage";
    colorBorderDark = "dark:border-color-dark-model-account-plan-sausage";
    colorBorderLight = "border-color-model-account-plan-sausage";
    colorTextDark = "dark:text-color-dark-model-account-plan-sausage";
    colorTextLight = "text-color-model-account-plan-sausage";
  }

  if (modelId.startsWith("account_plan_sausage_execution__")) {
    title = "Account Plan Sausage Execution";
    colorBackgroundDark =
      "dark:bg-color-dark-model-account-plan-sausage-execution";
    colorBackgroundLight = "bg-color-model-account-plan-sausage-execution";
    colorBorderDark =
      "dark:border-color-dark-model-account-plan-sausage-execution";
    colorTextDark = "dark:text-color-dark-model-account-plan-sausage-execution";
    colorTextLight = "text-color-model-account-plan-sausage-execution";
    colorBorderLight = "border-color-model-account-plan-sausage-execution";
  }

  if (modelId.startsWith("account_user__")) {
    title = "Account User";
    colorBackgroundDark = "dark:bg-color-dark-model-user";
    colorBackgroundLight = "bg-color-model-user";
    colorBorderDark = "dark:border-color-dark-model-user";
    colorBorderLight = "border-color-model-user";
    colorTextDark = "dark:text-color-dark-model-user";
    colorTextLight = "text-color-model-user";
  }

  if (modelId.startsWith("account_user_pii__")) {
    title = "Account User PII";
    colorBackgroundDark = "dark:bg-color-dark-model-user-pii";
    colorBackgroundLight = "bg-color-model-user-pii";
    colorBorderDark = "dark:border-color-dark-model-user-pii";
    colorBorderLight = "border-color-model-user-pii";
    colorTextDark = "dark:text-color-dark-model-user-pii";
    colorTextLight = "text-color-model-user-pii";
  }

  if (modelId.startsWith("account_user_status__")) {
    title = "Account User Status";
    colorBackgroundDark = "dark:bg-color-dark-model-user-status";
    colorBackgroundLight = "bg-color-model-user-status";
    colorBorderDark = "dark:border-color-dark-model-user-status";
    colorBorderLight = "border-color-model-user-status";
    colorTextDark = "dark:text-color-dark-model-user-status";
    colorTextLight = "text-color-model-user-status";
  }

  if (modelId.startsWith("incident__")) {
    title = "Incident";
    colorBackgroundDark = "dark:bg-color-dark-model-incident";
    colorBackgroundLight = "bg-color-model-incident";
    colorBorderDark = "dark:border-color-dark-model-incident";
    colorBorderLight = "border-color-model-incident";
    colorTextDark = "dark:text-color-dark-model-incident";
    colorTextLight = "text-color-model-incident";
  }

  if (modelId.startsWith("incident_status__")) {
    title = "Incident Status";
    colorBackgroundDark = "dark:bg-color-dark-model-incident-status";
    colorBackgroundLight = "bg-color-model-incident-status";
    colorBorderDark = "dark:border-color-dark-model-incident-status";
    colorBorderLight = "border-color-model-incident-status";
    colorTextDark = "dark:text-color-dark-model-incident-status";
    colorTextLight = "text-color-model-incident-status";
  }

  if (modelId.startsWith("note__")) {
    title = "Note";
    colorBackgroundDark = "dark:bg-color-dark-model-note";
    colorBackgroundLight = "bg-color-model-note";
    colorBorderDark = "dark:border-color-dark-model-note";
    colorBorderLight = "border-color-model-note";
    colorTextDark = "dark:text-color-dark-model-note";
    colorTextLight = "text-color-model-note";
  }

  if (modelId.startsWith("organisation__")) {
    title = "Organisation";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation";
    colorBackgroundLight = "bg-color-model-organisation";
    colorBorderDark = "dark:border-color-dark-model-organisation";
    colorBorderLight = "border-color-model-organisation";
    colorTextDark = "dark:text-color-dark-model-organisation";
    colorTextLight = "text-color-model-organisation";
  }

  if (modelId.startsWith("organisation_activity__")) {
    title = "Organisation Activity";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-activity";
    colorBackgroundLight = "bg-color-model-organisation-activity";
    colorBorderDark = "dark:border-color-dark-model-organisation-activity";
    colorBorderLight = "border-color-model-organisation-activity";
    colorTextDark = "dark:text-color-dark-model-organisation-activity";
    colorTextLight = "text-color-model-organisation-activity";
  }

  if (modelId.startsWith("organisation_tag__")) {
    title = "Organisation Tag";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-tag";
    colorBackgroundLight = "bg-color-model-organisation-tag";
    colorBorderDark = "dark:border-color-dark-model-organisation-tag";
    colorBorderLight = "border-color-model-organisation-tag";
    colorTextDark = "dark:text-color-dark-model-organisation-tag";
    colorTextLight = "text-color-model-organisation-tag";
  }

  if (modelId.startsWith("organisation_transfer__")) {
    title = "Organisation Transfer";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-transfer";
    colorBackgroundLight = "bg-color-model-organisation-transfer";
    colorBorderDark = "dark:border-color-dark-model-organisation-transfer";
    colorBorderLight = "border-color-model-organisation-transfer";
    colorTextDark = "dark:text-color-dark-model-organisation-transfer";
    colorTextLight = "text-color-model-organisation-transfer";
  }

  if (modelId.startsWith("organisation_user__")) {
    title = "Organisation User";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-user";
    colorBackgroundLight = "bg-color-model-organisation-user";
    colorBorderDark = "dark:border-color-dark-model-organisation-user";
    colorBorderLight = "border-color-model-organisation-user";
    colorTextDark = "dark:text-color-dark-model-organisation-user";
    colorTextLight = "text-color-model-organisation-user";
  }

  if (modelId.startsWith("organisation_detail__")) {
    title = "Organisation Detail";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-detail";
    colorBackgroundLight = "bg-color-model-organisation-detail";
    colorBorderDark = "dark:border-color-dark-model-organisation-detail";
    colorBorderLight = "border-color-model-organisation-detail";
    colorTextDark = "dark:text-color-dark-model-organisation-detail";
    colorTextLight = "text-color-model-organisation-detail";
  }

  if (modelId.startsWith("organisation_detail_media__")) {
    title = "Organisation Detail Media";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-detail-media";
    colorBackgroundLight = "bg-color-model-organisation-detail-media";
    colorBorderDark = "dark:border-color-dark-model-organisation-detail-media";
    colorBorderLight = "border-color-model-organisation-detail-media";
    colorTextDark = "dark:text-color-dark-model-organisation-detail-media";
    colorTextLight = "text-color-model-organisation-detail-media";
  }

  if (modelId.startsWith("organisation_status__")) {
    title = "Organisation Status";
    colorBackgroundDark = "dark:bg-color-dark-model-organisation-status";
    colorBackgroundLight = "bg-color-model-organisation-status";
    colorBorderDark = "dark:border-color-dark-model-organisation-status";
    colorBorderLight = "border-color-model-organisation-status";
    colorTextDark = "dark:text-color-dark-model-organisation-status";
    colorTextLight = "text-color-model-organisation-status";
  }

  if (modelId.startsWith("payment_method__")) {
    title = "Payment Method";
    colorBackgroundDark = "dark:bg-color-dark-model-payment-method";
    colorBackgroundLight = "bg-color-model-payment-method";
    colorBorderDark = "dark:border-color-dark-model-payment-method";
    colorBorderLight = "border-color-model-payment-method";
    colorTextDark = "dark:text-color-dark-model-payment-method";
    colorTextLight = "text-color-model-payment-method";
  }

  if (modelId.startsWith("staff_member__")) {
    title = "Staff Member";
    colorBackgroundDark = "dark:bg-color-dark-model-staff-member";
    colorBackgroundLight = "bg-color-model-staff-member";
    colorBorderDark = "dark:border-color-dark-model-staff-member";
    colorBorderLight = "border-color-model-staff-member";
    colorTextDark = "dark:text-color-dark-model-staff-member";
    colorTextLight = "text-color-model-staff-member";
  }

  if (modelId.startsWith("ticket__")) {
    title = "Ticket";
    colorBackgroundDark = "dark:bg-color-dark-model-ticket";
    colorBackgroundLight = "bg-color-model-ticket";
    colorBorderDark = "dark:border-color-dark-model-ticket";
    colorBorderLight = "border-color-model-ticket";
    colorTextDark = "dark:text-color-dark-model-ticket";
    colorTextLight = "text-color-model-ticket";
  }

  if (isSmall) {
    showTitle = false;
    paddingX = "px-2";
    return (
      <i
        onClick={onClick}
        className={`fas fa-database text-xs cursor-pointer hover:scale-95 focus:scale-90 active:scale-90 transition-all
        ${colorTextDark} ${colorTextLight}
      `}
      />
    );
  }

  if (isOutline) {
    colorBackgroundDark = "transparent";
    colorBackgroundLight = "transparent";
  }

  return (
    <div
      className={`flex flex-row gap-2 w-fit items-center  h-fit rounded-md py-1 text-xs font-semibold hover:scale-95 transition-all cursor-pointer 
      `}
      onClick={onClick}
    >
      {isShowingIcon && (
        <i className={`fas fa-database ${colorTextDark} ${colorTextLight} `} />
      )}
      {showTitle && <div className="opacity-60 whitespace-nowrap">{title}</div>}
    </div>
  );
};

export default ModelTag;
